// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"328":"650bdfb7","368":"b5639038","646":"4d98d226","716":"f437343f","853":"82ea2123","936":"e194ee14"}[chunkId] + ".css";
};